






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListingDetail } from '../models/ListingDetail';
import { ParcelAssessment } from '../models/ParcelAssessment';
import { TaxAssessment } from '../models/TaxAssessment';
import LoginRequiredPanel from '@/components/LoginRequiredPanel.vue';
import ChartBar from '@/components/ChartBar.vue';

@Component({
    components: {
        ChartBar,
        LoginRequiredPanel,
    },
})
export default class TaxesPanel extends Vue {

    @Prop(String) public readonly detailType: string | undefined;

    public widthThresholdValue: number = 768;
    public taxAssessments: TaxAssessment[] = [];
    public allYears: number[] = [];
    public allValues: number[] = [];
    public columns = [
        {name: 'Year', label: 'Year', align: 'left', field: 'Year'},
        {name: 'AmountAsText', label: 'Amount', align: 'left', field: 'AmountAsText'},
        {name: 'info', label: '% Change', align: 'left', field: (row: TaxAssessment) => ''},
    ];

    public datacollection: any = {
          labels: this.allYears,
          datasets: [
            {
              label: '',
              backgroundColor: '#007dc3',
              data: [],
            }],
        };
    public options = {
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    callback: (value: any, index: any, values: any) => {
                        return '$' + value;
                    },
                },
                gridLines: {
                    display: true,
                },
            }],
            xAxes: [{
                ticks: {
                    beginAtZero: true,
                },
                gridLines: {
                    display: false,
                },
            }],
        },
        legend: {
            display: false,
        },
        tooltips: {
            enabled: true,
            mode: 'single',
            callbacks: {
                label: (tooltipItems: any, data: any) => {
                    return '$' + tooltipItems.yLabel;
                },
            },
        },
        responsive: true,
        maintainAspectRatio: false,
        height: 100,
        plugins: {
            labels: {
                fontColor: 'white',
                render: (args: any ) => {
                        return '';
                },
            },
        },
    };

    get isLoggedIn() {
        return this.$store.state.isLoggedIn;
    }

    get isMobile(): boolean {
        return this.$q.screen.width <= this.widthThresholdValue;
    }

    get allTaxAssessments(): TaxAssessment[] {
        return this.taxAssessments!.reverse();
    }

    get ParcelAssessments(): ParcelAssessment[] {
        if (this.detailType === 'parcel') {
            if (this.$store.state.parcels.selectedParcelDetail && this.$store.state.parcels.selectedParcelDetail.ParcelData.ParcelAssessments) {
                return this.$store.state.parcels.selectedParcelDetail.ParcelData.ParcelAssessments;
            }
        }
        if (this.detailType === 'listing') {
            if (this.$store.state.listings.selectedListingDetail && this.$store.state.listings.selectedListingDetail.ParcelData.ParcelAssessments) {
                return this.$store.state.listings.selectedListingDetail.ParcelData.ParcelAssessments;
            }
        }
        return [];
    }

    public mounted() {
        this.initializeTaxAssessments();
        this.fillData();
    }

    public initializeTaxAssessments(): void {
        for (let i = this.ParcelAssessments.length - 1; i >= 0; i--) {
            const parcelAssessment = this.ParcelAssessments[i];
            const index = this.ParcelAssessments.length - 1 - i;
            const formattedPrice = this.formattedPrice(parcelAssessment.Value);
            let percentChange = 0;
            let isPosChange = false;
            let isNegChange = false;
            if (index !== 0) {
                percentChange = (Math.abs((parcelAssessment.Value - this.taxAssessments![index - 1].Amount) / (Math.abs(this.taxAssessments![index - 1].Amount)) * 100));

                if (parcelAssessment.Value > this.taxAssessments![index - 1].Amount) {
                    isPosChange = true;
                } else if (this.taxAssessments![index - 1].Amount > parcelAssessment.Value) {
                    isNegChange = true;
                }
            }

            const taxAssessment = new TaxAssessment(index, parcelAssessment.Year, parcelAssessment.Value, formattedPrice,
                                                  parseFloat(percentChange.toFixed(1)), isPosChange, isNegChange);
            this.taxAssessments?.push(taxAssessment);
            this.allValues?.push(parcelAssessment.Value);
            this.allYears?.push(parcelAssessment.Year);
        }
    }

    public formattedPrice(listPrice: number): string {
        if (listPrice === null || listPrice === undefined) {
            return 'Unknown';
        }

        try {
            if (typeof listPrice === 'string') {
                listPrice = parseInt(listPrice, 10);
            }

            if (listPrice.toString().indexOf('$') !== -1) {
                return listPrice.toString();
            }

            let lPrice = listPrice.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            lPrice = '$' + lPrice.substr(0, lPrice.length - 3);

            return lPrice;
        } catch {
            return 'Unknown';
        }
    }

    public fillData() {
        this.datacollection = {
            labels: this.allYears,
            datasets: [{
                label: '',
                backgroundColor: '#007dc3',
                data: this.allValues,
            }],
        };
      }
}

